import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';


export const getTaskDetails = ({taskID}) => {
  const data = {taskID: parseInt(taskID, 10)};

  return axios.post(api.GET_TASK_DETAILS, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
      const {task} = body;

      return task
    })
    .catch((err) => {
      console.error('GET_TASK_DETAILS returns error:');
      console.error(err);
    });
};
